import { useMemo, useState } from 'react';
import styled from 'styled-components';
import { eventApi } from '../../../core/api/rtk-query/event.api';

const Backdrop = styled.div`position: fixed; inset: 0; background: rgba(0,0,0,0.4); display: grid; place-items: center; z-index: 500; overflow-y: auto; padding: 20px;`;
const Modal = styled.div`width: 720px; max-width: 100%; background: #fff; border-radius: 16px; padding: 24px; box-shadow: 0 16px 48px rgba(0,0,0,0.12); margin: auto;`;
const Input = styled.input`padding: 10px 12px; border-radius: 10px; border: 1px solid #dbe3f6; background: #fff; width: 100%; box-sizing: border-box;`;
const Btn = styled.button`background: #fff; border: 1px solid #dbe3f6; color: #0b1221; padding: 8px 12px; border-radius: 10px; cursor:pointer;`;
const Row = styled.div`display: flex; gap: 8px; align-items: center;`;
const EventList = styled.div`max-height: 400px; overflow-y: auto; border: 1px solid #e5e8f0; border-radius: 12px; margin-top: 12px;`;
const EventItem = styled.div`display: flex; justify-content: space-between; align-items: center; padding: 10px 12px; border-bottom: 1px solid #eef1f6; &:last-child { border-bottom: none; }`;
const ComboWrap = styled.div`position: relative;`;
const ComboList = styled.ul`position: absolute; left: 0; right: 0; top: calc(100% + 6px); z-index: 50; list-style: none; margin: 0; padding: 8px 0; max-height: 240px; overflow: auto; background: #fff; border: 1px solid #dbe3f6; border-radius: 12px; box-shadow: 0 8px 28px rgba(0,0,0,.08);`;
const ComboItem = styled.li`padding: 8px 12px; cursor: pointer; &:hover { background: #f7f9ff; }`;

type Props = { group: { id: string; name: string }; onClose: () => void };

export const GroupEventsModal = ({ group, onClose }: Props) => {
  const { data: groupEvents, refetch: refetchEvents } = eventApi.useGetEventsQuery();
  const [eventQuery, setEventQuery] = useState('');
  const [eventOpen, setEventOpen] = useState(false);
  const { data: eventOptions } = eventApi.useSearchEventsQuery({ q: eventQuery, limit: 10 });
  const [grantEventAccess] = eventApi.useGrantEventAccessForGroupMutation();
  const [updateEvent] = eventApi.useUpdateEventMutation();
  const [removeEventFromGroup] = eventApi.useRemoveEventFromGroupMutation();

  // Фильтруем события, привязанные к этой группе
  const linkedEvents = useMemo(() => {
    if (!groupEvents) return [];
    return groupEvents.filter((e: any) => e.groupId === group.id);
  }, [groupEvents, group.id]);

  return (
    <Backdrop onClick={onClose}>
      <Modal onClick={e => e.stopPropagation()}>
        <Row style={{ justifyContent: 'space-between', marginBottom: 16 }}>
          <h3 style={{ margin: 0 }}>Мероприятия потока: {group.name}</h3>
          <Btn onClick={onClose}>Закрыть</Btn>
        </Row>

        <div>
          <div style={{ fontSize: 12, color: '#465676', marginBottom: 6 }}>Привязать мероприятие</div>
          <Row>
            <ComboWrap style={{ flex: 1 }}>
              <Input
                placeholder="Название мероприятия..."
                value={eventQuery}
                onChange={e => { setEventQuery(e.target.value); setEventOpen(true); }}
                onFocus={() => setEventOpen(true)}
                onBlur={() => setTimeout(() => setEventOpen(false), 120)}
              />
              {eventOpen && (eventOptions || []).length > 0 && (
                <ComboList>
                  {(eventOptions || []).map((ev: any) => (
                    <ComboItem key={ev.id} onMouseDown={async () => { 
                      try {
                        // Сначала обновляем событие, устанавливая groupId
                        await updateEvent({
                          id: ev.id,
                          name: ev.name,
                          description: ev.description || '',
                          type: ev.type,
                          startTime: ev.startTime,
                          endTime: ev.endTime,
                          duration: ev.duration || '00:45:00',
                          minimumPointsToPass: ev.minimumPointsToPass,
                          groupId: group.id,
                        }).unwrap();
                        
                        // Затем добавляем всех пользователей группы к событию
                        await grantEventAccess({ eventId: ev.id, groupId: group.id }).unwrap(); 
                        
                        await refetchEvents();
                        setEventQuery(''); 
                        setEventOpen(false);
                        alert('Мероприятие успешно привязано к потоку!');
                      } catch (error) {
                        console.error('Ошибка привязки:', error);
                        alert('Ошибка привязки: ' + JSON.stringify(error));
                      }
                    }}>
                      {ev.name}
                    </ComboItem>
                  ))}
                </ComboList>
              )}
            </ComboWrap>
          </Row>
        </div>

        <div style={{ marginTop: 20, paddingTop: 20, borderTop: '1px solid #e5e8f0' }}>
          <h4 style={{ margin: '0 0 12px 0' }}>Список мероприятий ({linkedEvents.length})</h4>
          <EventList>
            {linkedEvents.map((e: any) => (
              <EventItem key={e.id}>
                <div>
                  <div style={{ fontWeight: 500 }}>{e.name}</div>
                  <div style={{ fontSize: 12, color: '#667' }}>{e.type}</div>
                </div>
                <Btn onClick={async () => { 
                  if (window.confirm('Отвязать мероприятие?')) {
                    await removeEventFromGroup({ eventId: e.id, groupId: group.id }).unwrap(); 
                    await refetchEvents();
                  }
                }}>Отвязать</Btn>
              </EventItem>
            ))}
            {linkedEvents.length === 0 && <div style={{ padding: 12, color: '#667', textAlign: 'center' }}>Нет мероприятий</div>}
          </EventList>
        </div>
      </Modal>
    </Backdrop>
  );
};
